module.exports = __webpack_public_path__ + "static/media/creative.83a44862.png";